import { instrumentApi } from "@api";
import { getDateListMonth, theme } from "@utils";
import { useEffect, useState } from "react";
import { holidayApi } from "src/Api/holiday";
import { TitleMenuComponent } from "../TitleMenuComponent";
import { menuTitleEnums } from "@enums";
import { BorrowingCalendarContent } from "../Vehicles/BorrowingCalendarContent";
import { StyledVehicleBorrowingCalendar } from "../Vehicles";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

interface LocationState {
  searchWord?: any;
}

export const InstrumentBorrowingCalendar = () => {
  const location = useLocation<LocationState>();
  const [holidays, setHolidays] = useState<string[]>([]);
  const [month, setMonth] = useState<string>(new Date().toISOString().slice(0, 7));
  const [instruments, setInstruments] = useState<any[]>([]);
  const searchWord = location.state?.searchWord || "";

  useEffect(() => {
    fetchListBorrowing();
    fetchHoliday();
  }, [month]);

  const fetchHoliday = async () => {
    try {
      const res = await holidayApi.getMonthHolidays({
        year: parseInt(month.slice(0, 4)),
        month: parseInt(month.slice(5, 7)),
        page_key: "instrument"
      });
      const holidayDates = res.data.data.date_holiday.map((d) => d.date);
      setHolidays(holidayDates);

    } catch (error) {
      console.error("休日情報取得失敗", error);
    }
  };

  // const fullState = useSelector((state) => state);
  // console.log("全state", fullState);

  //機器リストの検索結果をReduxから取得
  const filterResult = useSelector((state: { instrument: { dataResult: any } }) => state.instrument.dataResult);
  // console.log("機器リストの検索結果", filterResult);

  const fetchListBorrowing = async () => {
    try {

      let data: { year: number; month: number; category_id?: number; subCategory_id?: number, searchWord?: string } = {
        year: parseInt(month.slice(0, 4)),
        month: parseInt(month.slice(5, 7)),
      };

      //機器リストで検索結果がある場合、カテゴリーIDとサブカテゴリーIDを追加
      if (filterResult?.categoryId) {
        data.category_id = filterResult.categoryId;
        data.subCategory_id = filterResult.subCategoryId;
      }

      //文字検索していた場合は検索ワードを追加
      if (searchWord?.trim()) {
        data.searchWord = searchWord;
      }

      const res = await instrumentApi.getInstrumentBorrowingList(data);

      // console.log("機器リスト", res.data);
      setInstruments(res.data.data);

    } catch (error) {
      console.error("車両リスト取得失敗", error);
    }
  };

  const handleMonthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = event.target.value;
    setMonth(selectedDate);
  };

  const dateListArray = getDateListMonth(month);

  return (
    <StyledVehicleBorrowingCalendar>
      <div>
        <div className="topTitle">
          <TitleMenuComponent text={menuTitleEnums.TITLE_INSTRUMENTS} />
        </div>
        <div className="wrapperInput">
          <div className="datePicker">
            <div className="label" >日付</div>
            <div className="wrapperDatePicker">
              <input
                type="month"
                value={month}
                onChange={handleMonthChange}
                style={{
                  padding: "1rem",
                  borderRadius: "24px",
                  border: `1px solid ${theme.colors.gray03}`,
                  fontSize: "1.5rem",
                  fontFamily: "NotoSansJP-500",
                  color: `${theme.colors.black01}`,
                  backgroundColor: `${theme.colors.white02}`,
                }}
              />
            </div>
          </div>
        </div>

        <BorrowingCalendarContent data={instruments} dateList={dateListArray} holidays={holidays} itemType="instruments" />

      </div>
    </StyledVehicleBorrowingCalendar>
  );
};
